export const getEnvVariable = function (
    environmentVariable: string
): string {
    let validEnvironmentVariable: string | undefined;

    if (typeof process !== 'undefined' && process.env) {
        validEnvironmentVariable = process.env[environmentVariable];
    }

    if (!validEnvironmentVariable && typeof import.meta !== 'undefined' && (import.meta as any).env) {
        validEnvironmentVariable = (import.meta as any).env[environmentVariable];
    }

    if (!validEnvironmentVariable) {
        throw new Error(`Couldn't find environment variable: ${environmentVariable}`);
    }
    return validEnvironmentVariable;
}

export const getOptionalEnvVariable = function (
    environmentVariable: string
): string | undefined {
    let enVar: string | undefined;

    if (typeof process !== 'undefined' && process.env) {
        enVar = process.env[environmentVariable];
    }

    if (!enVar && typeof import.meta !== 'undefined' && (import.meta as any).env) {
        enVar = (import.meta as any).env[environmentVariable];
    }

    if (!enVar) {
        console.warn(`Couldn't find environment variable: ${environmentVariable}`);
    }
    return enVar;
}

let isVite = typeof import.meta !== 'undefined' && (import.meta as any).env
export const IS_PROD = isVite ? ((import.meta as any).env.PROD) : (getOptionalEnvVariable("NODE_ENV") === "production");

if (typeof process !== 'undefined' && process.env && !IS_PROD) {
    console.log("NODE_TLS_REJECT_UNAUTHORIZED disabled for DEV ONLY");
    process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
}